export default __webpack_public_path__ + "static/media/risk-result-4.085619a3.svg";